import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, role } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only stop loading when we have BOTH user and role information
    if (user !== undefined) {
      // If no role is required, we can proceed immediately
      if (!requiredRole) {
        const timer = setTimeout(() => setLoading(false), 500);
        return () => clearTimeout(timer);
      }
      
      // If a role is required, wait until we have role information
      if (role !== null) {
        const timer = setTimeout(() => setLoading(false), 500);
        return () => clearTimeout(timer);
      }
    }
  }, [user, role, requiredRole]);

  // Add a timeout to prevent infinite loading if role fetch fails
  useEffect(() => {
    const maxWaitTimer = setTimeout(() => {
      if (loading && user) {
        console.log('Max wait time reached, proceeding with available auth info');
        setLoading(false);
      }
    }, 5000); // 5 second maximum wait

    return () => clearTimeout(maxWaitTimer);
  }, [loading, user]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-nn-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && role !== requiredRole) {
    console.log('Access denied: User role', role, 'does not match required role', requiredRole);
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;